export const toDigits = (n: number | string, length = 2): number => {
    const p = 10 ** length;
    return Math.floor(Number(n) * p) / p;
};
